<template>
    <div class="container-fluid">
        <Breadcrumb title="Add PMTA Relay" v-bind:button-show="false" v-show="!id"></Breadcrumb>
        <Breadcrumb v-bind:title="'Edit PMTA Relay #' + id" v-bind:button-show="false" v-show="id"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="id">
                <Preloader v-bind:class="{preloader: loading}" v-show="loading"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card" v-show="id">
                    <div class="card-body">
                        <div class="form-group mb-0">
                            <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                    @click="getRelayDkim"><i
                                    class="fa fa-key"></i>
                                Get DKIM public key
                                <div v-if="waiting === 'dkim'"
                                     class="spinner-grow spinner-grow-sm" role="status"></div>
                            </button>
                            <button type="button" class="btn btn-warning btn-rounded mr-2 mb-2"
                                    @click="generateRelayDkim"><i
                                    class="fas fa-plus-circle"></i>
                                Generate DKIM key
                            </button>
                            <button type="button" class="btn btn-warning btn-rounded mr-2 mb-2"
                                    @click="deleteRelayDkim"><i
                                    class="fas fa-times-circle"></i>
                                Delete DKIM key
                            </button>
                            <br/>
                            <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                    @click="getRelayVmtaDate"><i
                                    class="fas fa-download"></i>
                                Check date of VMTA config
                                <div v-if="waiting === 'vmtaDate'"
                                     class="spinner-grow spinner-grow-sm" role="status"></div>
                            </button>
                            <button type="button" class="btn btn-warning btn-rounded mr-2 mb-2"
                                    @click="uploadRelayVmta"><i
                                    class="fas fa-upload"></i>
                                Upload VMTA config to PMTA
                            </button>
                            <button type="button" class="btn btn-warning btn-rounded mr-2 mb-2"
                                    @click="deleteRelayVmta"><i
                                    class="fas fa-times-circle"></i>
                                Delete VMTA config from PMTA
                            </button>
                            <br/>
                            <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                    @click="displaySwitches()">
                                <i class="fa fa-check-square"></i>
                                Mail Services
                            </button>
                        </div>
                    </div>
                </div>
                <transition>
                    <div class="card" v-show="switchesCardView">
                        <div class="card-body">
                            <button type="button" class="close" aria-label="Close" @click="switchesCardView = false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div>
                                <div class="form-group">
                                    <h4>Mail Services Switches</h4>
                                </div>
                                <div v-if="loadingSwitches" class="spinner-grow spinner-grow-sm" role="status"></div>
                                <div v-if="!loadingSwitches" class="table-responsive">
                                    <table class="table table-header-rotated">
                                        <thead>
                                        <tr>
                                            <th>
                                                <span>Service</span>
                                            </th>
                                            <th>
                                                <span>On/Off</span>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr class="align-middle" v-for="(relaySwitch, index) in switches" :key="index">
                                            <td>
                                                {{ relaySwitch.providerName }}
                                            </td>
                                            <td>
                                                <toggle-button :value="!relaySwitch.off" sync color="#00c292"
                                                               @change="changeSwitch(index)"
                                                               :labels="{checked: 'On', unchecked: 'Off'}"
                                                               :height="26" :width="52">
                                                </toggle-button>
                                            </td>                                          
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <button v-if="!loadingSwitches" type="button" class="btn btn-success btn-rounded mr-2 mb-2" v-bind:disabled="loadingSwitches" @click="saveSwitches()">
                                    <i v-if="savingSwitches" class="spinner-grow spinner-grow-sm" role="status"></i>
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </transition>
                <div class="card" v-if="!id">
                    <div class="card-body">
                        <div class="form-group" v-if="uploadingFiles.length">
                            <h5>Now uploading files:</h5>
                            <div v-for="(list, index) in uploadingFiles" :key="index">
                                <h3 class="mb-1 mt-3" style="font-size:18px;">
                                    {{list.label}}
                                    <span style="float:right;">{{list.completion}}</span>
                                </h3>
                                <div class="progress-bar bg-info" role="progressbar"
                                     v-bind:style="{width: list.completion, height: '3px'}"
                                     aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">
                                </div>
                            </div>
                        </div>
                        <div class="form-group mb-0">
                            <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                    @click="uploadCard1View = true">
                                <i class="fas fa-upload"></i>
                                Upload a list ver 1
                            </button>
                            <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                    @click="uploadCard2View = true">
                                <i class="fas fa-upload"></i>
                                Upload a list ver 2
                            </button>
                        </div>
                    </div>
                </div>
                <transition>
                    <div class="card" v-if="!id" v-show="uploadCard1View" :key="$route.fullPath">
                        <div class="card-body">
                            <button type="button" class="close" aria-label="Close" @click="uploadCard1View = false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div>
                                <div class="form-group">
                                    <h4>Upload a list of PMTA Relays</h4>
                                    <small class="form-text text-muted mt-0">
                                        <br/>
                                        Header is required. Field separator is comma. Example:<br/>
                                        smtpHost,ip,senderEmail,active,withoutVmta<br/>
                                        legit.net,12.31.14.51,noreply@legit.net,true,false<br/>
                                        relay.com,182.13.85.201,info@relay.com,false,true<br/>
                                    </small>
                                </div>
                                <div class="form-group text-left" v-if="this.$store.getters.isAdmin">
                                    <label>Select Relay Owner</label>
                                    <treeselect placeholder="Select User"
                                                v-model="owner"
                                                :multiple="false"
                                                :options="userList"
                                                :load-options="loadUserList"
                                                value-format="object"
                                                @input="ownerSelected"
                                    />
                                </div>
                                <div class="form-group text-left">
                                    <label>Select PMTA Server</label>
                                    <treeselect placeholder="Select Server"
                                                v-model="server"
                                                :multiple="false"
                                                :options="serverList"
                                                value-format="object"
                                    />
                                </div>
                                <div class="form-group text-left">
                                    <label>Select Relay Group</label>
                                    <treeselect placeholder="Select Group"
                                                v-model="group"
                                                :multiple="false"
                                                :options="groupList"
                                                value-format="object"
                                    />
                                </div>
                                <div class="form-group text-left">
                                    <input type="file" id="relays" accept="text/csv" class="w-100"/>
                                </div>
                                <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                        @click="listUpload(false)">
                                    <i class="fas fa-upload"></i>
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                </transition>
                <transition>
                    <div class="card" v-if="!id" v-show="uploadCard2View" :key="$route.fullPath">
                        <div class="card-body">
                            <button type="button" class="close" aria-label="Close" @click="uploadCard2View = false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div>
                                <div class="form-group">
                                    <h4>Upload a list of PMTA Relays</h4>
                                    <small class="form-text text-muted mt-0">
                                        <br/>
                                        Header is required. Field separator is comma. Example:<br/>
                                        pmtaServerId,pmtaRelayGroupId,smtpHost,ip,senderEmail,active,withoutVmta<br/>
                                        1,1,legit.net,12.31.14.51,noreply@legit.net,true,false<br/>
                                        2,2,relay.com,182.13.85.201,info@relay.com,false,true<br/>
                                    </small>
                                </div>
                                <div class="form-group text-left">
                                    <input type="file" id="relays_allin" accept="text/csv" class="w-100"/>
                                </div>
                                <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                        @click="listUpload(true)">
                                    <i class="fas fa-upload"></i>
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                </transition>
                <div class="card">
                    <div class="card-body">
                        <PmtaRelayForm :id="id" @hidePreloader="hidePreloader"></PmtaRelayForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import PmtaRelayForm from './forms/PmtaRelayForm';
    import Breadcrumb from '../components/Breadcrumb';
    import PmtaRelayService from '../services/PmtaRelayService';
    import Swal from 'sweetalert2';
    import Treeselect from '@riophae/vue-treeselect';
    import UploadFileService from '../services/UploadFileService';
    import PmtaServerService from '../services/PmtaServerService';
    import PmtaRelayGroupService from '../services/PmtaRelayGroupService';
    import config from '../config';
    import {mapGetters} from 'vuex';
    import {FileType} from '../constants';
    import UserService from '../services/UserService';
    import PmtaRelayMailProviderSwitchService from '../services/PmtaRelayMailProviderSwitchService';

    export default {
        name: 'PmtaRelay',
        props: ['id'],
        components: {
            Preloader, PmtaRelayForm, Breadcrumb, Treeselect
        },
        data() {
            return {
                loading: false,
                waiting: null,
                uploadCard1View: false,
                uploadCard2View: false,
                uploadingFiles: [],
                serverList: [],
                groupList: [],
                userList: null,
                server: null,
                group: null,
                owner: null,
                switchesCardView: false,                
                loadingSwitches: false,
                savingSwitches: false,
                switches: [],
            }
        },
        mounted() {            
            if (this.id) {
                this.loading = true;
            } else {
                this.getUploadingFiles();
                this.listUploadProgress();
            }
            if (!this.$store.getters.isAdmin) {
                this.loadServerList();
                this.loadGroupList();
            }
        },
        computed: {
            ...mapGetters({mercureListen: 'listen'})
        },
        methods: {
            displaySwitches() {
                if (!this.id) {
                    return;
                }
                this.switchesCardView = true;
                this.getSwitches();
            },
            changeSwitch(index) {
                this.switches[index].off = !this.switches[index].off;
            },
            saveSwitches() {
                this.savingSwitches = true;
                PmtaRelayMailProviderSwitchService.updateSwitches(this.id, this.switches).then(() => {
                    this.savingSwitches = false;
                });
            },
            getSwitches() {
                this.loadingSwitches = true;
                PmtaRelayMailProviderSwitchService.getSwitches(this.id).then(response => {
                    this.switches = response.data.switches;
                    this.loadingSwitches = false;
                });
            },
            hidePreloader(value) {
                this.loading = value
            },
            getUploadingFiles() {
                UploadFileService.getFiles(FileType['PMTA_RELAYS']).then(response => {
                    if (response.status === 200) {
                        this.uploadingFiles = this.uploadingFiles.concat(response.data['hydra:member'].map(file => {
                            return {id: file.id, label: file.originalName, completion: '0%'}
                        }));
                    }
                });
                UploadFileService.getFiles(FileType['PMTA_RELAYS_ALLIN']).then(response => {
                    if (response.status === 200) {
                        this.uploadingFiles = this.uploadingFiles.concat(response.data['hydra:member'].map(file => {
                            return {id: file.id, label: file.originalName, completion: '0%'}
                        }));
                    }
                });
            },
            listUploadProgress() {
                if (!this.mercureListen.hasOwnProperty(config.uploadPmtaRelaysProgressStatus)) {
                    let url = new URL(config.mercureHubUrl);
                    url.searchParams.append('topic', config.uploadPmtaRelaysProgressStatus);
                    let eventSource = new EventSource(url);
                    this.$store.commit('setListening', {[config.uploadPmtaRelaysProgressStatus]: eventSource});
                }
                this.mercureListen[config.uploadPmtaRelaysProgressStatus].onmessage = event => {
                    let data = JSON.parse(event.data);
                    if (data.fileId !== undefined) {
                        let index = this.uploadingFiles.findIndex(file => file.id === data.fileId);
                        if (index < 0) {
                            return;
                        } else {
                            this.uploadingFiles[index].completion = parseInt(data.completion) + '%';
                        }
                        if (data.error !== undefined) {
                            this.$snotify.error('File ' + this.uploadingFiles[index].label + ' processing error: ' + data.error);
                            this.uploadingFiles.splice(index, 1);
                            return;
                        }
                        if (100 === parseInt(data.completion)) {
                            this.$snotify.success('File ' + this.uploadingFiles[index].label + ' processing completed! Uploaded ' + data.createdCount + ' relays.');
                            this.uploadingFiles.splice(index, 1);
                        }
                    }
                }
            },
            loadServerList(byUserId) {
                PmtaServerService.getServerSelect(byUserId).then(response => {
                    this.serverList = response.data['hydra:member'].map(server => {
                        return {id: server.id, label: server.name}
                    });
                });
            },
            loadGroupList(byUserId) {
                PmtaRelayGroupService.getGroupSelect(byUserId).then(response => {
                    this.groupList = response.data['hydra:member'].map(group => {
                        return {id: group.id, label: group.name}
                    });
                });
            },
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            },
            listUpload(allIn) {
                let data = new FormData();
                let file = allIn ? document.getElementById('relays_allin').files[0] : document.getElementById('relays').files[0];
                data.append('relays', file);
                if (this.server) {
                    data.append('serverId', this.server.id);
                }
                if (this.group) {
                    data.append('groupId', this.group.id);
                }
                data.append('allIn', allIn);
                PmtaRelayService.uploadRelays(data).then(response => {
                    if (response.status === 200) {
                        Swal({
                            type: 'success',
                            title: 'File is accepted for processing',
                            text: 'It will take some time to process the data, please wait.'
                        });
                        this.getUploadingFiles();
                        this.uploadCard1View = false;
                        this.uploadCard2View = false;
                    } else {
                        Swal({
                            type: 'error',
                            title: 'Error',
                            text: response.data.error !== undefined ? response.data.error : 'Some error occurred.'
                        })
                    }
                });
            },
            ownerSelected() {
                if (this.owner !== undefined) {
                    this.loadServerList(this.owner.id);
                    this.loadGroupList(this.owner.id);
                } else {
                    this.serverList = [];
                    this.groupList = [];
                    this.server = null;
                    this.group = null;
                }
            },
            getRelayDkim() {
                this.waiting = 'dkim';
                PmtaRelayService.getRelayDkim(this.id).then(response => {
                    this.waiting = null;
                    Swal({
                        type: response.text.startsWith("Error:") ? 'error' : '',
                        title: 'Relay DKIM public key:',
                        html: response.text,
                        confirmButtonText: 'Close',
                    });
                });
            },
            generateRelayDkim() {
                Swal({
                    type: 'warning',
                    title: 'Are you sure you want to generate new DKIM key?',
                    text: 'If DKIM key already exists, then generation will not occur(first delete the old key).',
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return PmtaRelayService.generateRelayDkim(this.id)
                            .catch(error => {
                                Swal.showValidationMessage(
                                    'Error: ' + error.response.data.error[0]
                                )
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value.status === 200) {
                        Swal({
                                type: 'success',
                                title: 'Сommand was accepted successfully.',
                            }
                        )
                    }
                });
            },
            deleteRelayDkim() {
                Swal({
                    type: 'warning',
                    title: 'Are you sure you want to delete DKIM key?',
                    text: 'Don`t forget to apply this changes on your DNS.',
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return PmtaRelayService.deleteRelayDkim(this.id)
                            .catch(error => {
                                Swal.showValidationMessage(
                                    'Error: ' + error.response.data.error[0]
                                )
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value.status === 200) {
                        Swal({
                                type: 'success',
                                title: 'Сommand was accepted successfully.',
                            }
                        )
                    }
                });
            },
            getRelayVmtaDate() {
                this.waiting = 'vmtaDate';
                PmtaRelayService.getRelayVmtaDate(this.id).then(response => {
                    this.waiting = null;
                    Swal({
                        type: response.text.startsWith("Error:") ? 'error' : '',
                        title: 'VMTA config date:',
                        html: response.text,
                        confirmButtonText: 'Close',
                    });
                });
            },
            uploadRelayVmta() {
                Swal({
                    type: 'warning',
                    title: 'Are you sure you want to upload VMTA config to PMTA?',
                    text: 'Сurrent config(if exists) will be overwritten.',
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return PmtaRelayService.uploadRelayVmta(this.id)
                            .catch(error => {
                                Swal.showValidationMessage(
                                    'Error: ' + error.response.data.error[0]
                                )
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value.status === 200) {
                        Swal({
                                type: 'success',
                                title: 'Сommand was accepted successfully.',
                            }
                        )
                    }
                });
            },
            deleteRelayVmta() {
                Swal({
                    type: 'warning',
                    title: 'Are you sure you want to delete VMTA config from PMTA?',
                    text: 'This will delete relay(VMTA) from PMTA server(but not its DKIM).',
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return PmtaRelayService.deleteRelayVmta(this.id)
                            .catch(error => {
                                Swal.showValidationMessage(
                                    'Error: ' + error.response.data.error[0]
                                )
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value.status === 200) {
                        Swal({
                                type: 'success',
                                title: 'Сommand was accepted successfully.',
                            }
                        )
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .table-header-rotated th.rotate-45 {
        height: 100px;
        position: relative;
        vertical-align: bottom;
        padding: 0;
        font-size: 12px;
    }

    .table-header-rotated th.rotate-45 span {
        -ms-transform: rotate(270deg);
        -moz-transform: rotate(270deg);
        -webkit-transform: rotate(270deg);
        -o-transform: rotate(270deg);
        transform: rotate(270deg);
        position: absolute;
        bottom: 40px;
        left: -25px;
        width: 85px;
    }
</style>
